/** The Ватман mark: a sheet with two stickies. */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="16" style={{ fill: 'var(--brand-primary)' }} />
      <rect x="14" y="16" width="22" height="22" rx="3" style={{ fill: 'var(--brand-secondary)' }} />
      <rect x="28" y="28" width="22" height="22" rx="3" fill="#ffffff" fillOpacity="0.92" />
    </svg>
  );
}
